const Subscribe = ({ data }) => (
  <section id="subscribe" className="bg-near-white">
    <div className="container relative pv6">
      <TopBalls />
      <Pitch heading={data.heading} subheading={data.subheading} paragraph={data.paragraph} />
      <MailChimp />
      <BottomBalls />
    </div>
  </section>
)

export default Subscribe

/*
 *
 * General
 * 
 */

import React from 'react'

import Ball from '../components/Ball'

/*
 *
 * Top Balls
 * 
 */

const TopBalls = () => (
  <div>
    <Ball className="top-10 md:top-40 left-40 md:left-20 anim-diagonal-left bg-gold w1 h1" />
    <Ball className="top-10 md:top-50 left-50 md:left-10 anim-vertical anim-delay-2 bg-gray w2 h2" />
    <Ball className="top-15 md:top-60 left-60 md:left-10 anim-diagonal-right anim-delay-1 bg-gold w1 h1" />
  </div>
)

/*
 *
 * Pitch
 * 
 */

const Pitch = ({ heading, subheading, paragraph }) => (
  <div>
    <h2 className="heading mb3 tc gold">{heading}</h2>
    <h3 className="heading mb4 tc f3">
      <span className="light-gray">
        {subheading.gray}
        {` `}
      </span>
      <span className="gold">{subheading.gold}</span>
    </h3>
    <p className="ml-auto mr-auto mb4 measure-narrow tc lh-copy sm:tc">{paragraph}</p>
  </div>
)

/*
 *
 * MailChimp
 * 
 */

import MailChimpForm from '../components/MailChimpForm'

const MailChimp = () => (
  <MailChimpForm
    url="https://center.us12.list-manage.com/subscribe/post?u=02685a4a94f988fabd34b16c3&amp;id=e287276512"
    className="ml-auto mr-auto tc"
    style={{ maxWidth: `28ch` }}
  />
)

/*
 *
 * Bottom Balls
 * 
 */

const BottomBalls = () => (
  <div>
    <Ball className="top-90 md:top-40 left-40 md:left-75 anim-diagonal-right bg-gold w1 h1" />
    <Ball className="top-90 md:top-50 left-50 md:left-90 anim-vertical anim-delay-4 bg-gray w2 h2" />
    <Ball className="top-90 md:top-70 left-60 md:left-90 anim-diagonal-left anim-delay-1 bg-gold w1 h1" />
  </div>
)



// WEBPACK FOOTER //
// ./src/sections/Subscribe.js